module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-coin_53x58.png?v=73d9c29e";